import { TEAM_TYPES } from 'common/constants/constants';

export const CONFIG_ACTIONS = {
  ADD: 'add',
  EDIT: 'edit'
};

export const TEAMS_CONFIG = {
  [CONFIG_ACTIONS.ADD]: {
    [TEAM_TYPES.TEAM]: {
      title: 'Add Team',
      showWithHistory: true
    },
    [TEAM_TYPES.GROUP]: {
      title: 'Add Group'
    }
  },
  [CONFIG_ACTIONS.EDIT]: {
    [TEAM_TYPES.TEAM]: {
      title: 'Edit Team',
      showWithoutBackfill: true
    },
    [TEAM_TYPES.GROUP]: {
      title: 'Edit Group'
    }
  },
  [TEAM_TYPES.TEAM]: {
    showNestedTeams: false,
    FORM_FIELDS: {
      GITHUB_NAME: {
        title: 'Github Team name'
      },
      NAME: {
        title: 'Team name',
        error: 'A team with this name is already in use'
      },
      INITIALS: {
        title: 'Initials',
        error: 'These initials are already in use by another team'
      }
    }
  },
  [TEAM_TYPES.GROUP]: {
    showNestedTeams: true,
    FORM_FIELDS: {
      GITHUB_NAME: {
        title: 'Github Group name'
      },
      NAME: {
        title: 'Group name',
        error: 'A group with this name is already in use'
      },
      INITIALS: {
        error: 'These initials are already in use by another group'
      }
    }
  },
  FORM_FIELDS: {
    PARENT_GROUP: {
      title: 'Parent group'
    },
    COLOR: {
      title: 'Color'
    },
    INITIALS: {
      title: 'Initials'
    },
    NESTED_TEAMS: {
      title: 'Nested children'
    }
  }
};
